<template>
    <student-backend-layout
        page-title="Videos"
        content-bg-color="white"
        header-bg-color="white"
    >
        <template #content>
            <div class="flex w-full flex-col">
                <div
                    class="mb-8 mt-4 flex hidden items-center justify-start gap-1 px-4 text-[14px] leading-none text-gray-700 md:flex lg:px-10"
                >
                    <div class="border-b border-gray-300 font-semibold">
                        <Link :href="route('student.videos.index')"
                            >Videos
                        </Link>
                    </div>
                    <div class="">&raquo;</div>
                    <div class="">{{ video.title }}</div>
                </div>
                <div class="mb-4 aspect-video w-full md:px-4 lg:px-10">
                    <student-video :video="video" />
                </div>
                <div
                    class="mb-2 px-4 text-[28px] font-semibold text-gray-800 lg:px-10"
                >
                    {{ video.title }}
                </div>
                <div class="mb-4 px-4 text-[18px] text-gray-700 lg:px-10">
                    <span v-html="video.description"></span>
                </div>
                <div
                    class="flex flex-wrap items-center gap-2 px-4 text-[16px] lg:px-10"
                >
                    <div class="font-semibold text-gray-600">Topics</div>
                    <div
                        class="rounded-full bg-gray-300 px-4 py-2 font-semibold text-gray-700"
                        v-for="category in video.categories"
                    >
                        {{ category.title }}
                    </div>
                </div>

                <div
                    class="mt-8 flex flex-col gap-4 border-t border-gray-300 px-4 pt-4 lg:px-10"
                >
                    <div class="text-[20px] font-semibold">Related Videos</div>
                    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
                        <template v-for="video in relatedVideos">
                            <student-video-card :video="video" />
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </student-backend-layout>
</template>

<script>
import StudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import StudentVideoCard from "@/Components/StudentVideoCard.vue";
import VideoPlayer from "@/Components/VideoPlayer.vue";
import StudentVideo from "@/Components/StudentVideo.vue";

export default {
    name: "StudentVideoShow",
    components: {
        StudentVideo,
        StudentBackendLayout,
        VideoPlayer,
        StudentVideoCard,
    },
    props: {
        video: {
            type: Object,
            default: {},
        },
        relatedVideos: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>
